import { render, staticRenderFns } from "./ContactsPage.vue?vue&type=template&id=6f1ed2ae"
import script from "./ContactsPage.vue?vue&type=script&lang=ts"
export * from "./ContactsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports